
<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Carga una imagen</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit('')"></i></h1>
				</div>
				<div class="modal-body">
					<div class="input-group">
						<input type="file" class="form-control" (change)="fileChangeEvent($event)" />
					</div>
					<div class="row">
						<div class="col">
							<image-cropper style="max-height: 200px;" output="base64"
								[imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1"
								format="jpg" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded($event)"
								(cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
						</div>
						<div class="col" style="display: flex;width: 100%;justify-content: center;">
							<img [src]="croppedImage" style="max-height: 200px;" />
						</div>
					</div>

				</div>
				<div class="modal-footer">
					<button class="btn btn-info" [disabled]="!croppedImage" (click)="uploadImage()">
						<ng-container *ngIf="!uploadingImage">
							<i class="fa-solid fa-cloud-arrow-up"></i>
						</ng-container>
						<ng-container *ngIf="uploadingImage">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>SUBIR IMAGEN
					</button>
				</div>
			</div>
		</div>
	</div>
</div>